import {expectEitherAndCrash, HttpClient, HttpClient$, POST, ServerValidationResult} from '@raison/network-facade';
import {AccountId, CardId} from '@raison/types';
import {array, partial, string} from 'io-ts';
import {atom} from 'jotai';
import {Payment, StripeIntentSchema} from '../_schemas';

export const createPaymentAtom = atom(get => (accountId: AccountId, cardId: CardId, data: Payment) => {
    const http = get(HttpClient$);
    return createPayment(http, accountId, cardId, data);
});

export const createPayment = (http: HttpClient, accountId: AccountId, cardId: CardId, data: Payment) => {
    return http(`v1/accounts/${accountId}/receive/cards/${cardId}`, POST(data)).then(
        ...expectEitherAndCrash({
            200: StripeIntentSchema,
            400: ServerValidationResult.createCodecForType<Payment>()(
                partial({
                    amount: array(string),
                    card_id: array(string),
                    callback_url: array(string),
                })
            )
        })
    );
}
